import { useQuery } from "@tanstack/react-query";
import commentsService from "services/admin/commentsService";

export const useGetComments = (queryParams: object = {}) => {
    return useQuery({
        queryKey: ['getComments', queryParams],
        queryFn: async () => {
            const { data } = await commentsService.getComments(queryParams)
            return data
        },
        select: (data) => data,
        retry: false,
        refetchOnWindowFocus: true,
    })
}